import { getSdk } from "./sdkService";

// TODO: Add comments
export async function getAllMops() {
  const { stateActions } = this.props;
  try {
    const sdk = await getSdk();
    const result = await sdk.billingManager.getAllMopsForBigScreens();
    stateActions.setAllMops(result);
    return result;
  } catch (error) {
    throw error;
  }
}

export async function getPaymentMethodByPlanId(planId) {
  const { stateActions, applicationState } = this.props;
  if (applicationState.paymentMethods[planId]) {
    return applicationState.paymentMethods[planId];
  }

  const sdk = await getSdk();
  const paymentPlan = await sdk.billingManager.getPaymentMethodById(planId);
  stateActions.setPaymentMethods(paymentPlan);
  return paymentPlan[planId];
}
